import React, { memo } from "react"
import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { NavLink } from "react-router-dom"
import { Trans } from "@lingui/macro"
import { AuthorTools } from "@components/Author/AuthorTools"
import { AdornmentIcon } from "@components/Icon/AdornmentIcon"
import { Avatar } from "@components/Avatar/Avatar"
import TimeAgo from "@components/TimeAgo"
import { RowBox } from "@components/Boxes/RowBox"
import { FlexBox } from "@components/Boxes/FlexBox"
import { ActionCard } from "@components/ActionCards/ActionCard"

const useStyles = makeStyles((theme) => ({
  footer: {
    color: theme.palette.text.secondary
  },
  lastUpdated: {
    color: theme.palette.text.secondary
  },
  restrictedText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "16px",
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1)
  }
}))

const ListArticle = memo(({ knowledge, onEdit, onDelete, onCopy, hasGroupsOrLocations, onMove }) => {
  const classes = useStyles()

  const { id, title, author, createdAt, updatedAt, isRestrictedToKiosk } = knowledge

  const renderFooter = () => (
    <RowBox className={classes.footer} alignItems="center" width="100%">
      {hasGroupsOrLocations && (
        <Box mr={1}>
          <AdornmentIcon name="restricted" tooltip={<Trans>Restricted to locations and/or areas of work</Trans>} />
        </Box>
      )}
      {isRestrictedToKiosk && (
        <FlexBox>
          <AdornmentIcon name="phone-link-lock" tooltip={<Trans>Restricted to access on kiosk devices</Trans>} />
          <Box className={classes.restrictedText}>
            <Trans>Restricted to kiosk</Trans>
          </Box>
        </FlexBox>
      )}
      <Box flexGrow={1} />
      <RowBox className={classes.lastUpdated}>
        {updatedAt !== createdAt && (
          <Box mr={1}>
            <Trans>Updated</Trans> <TimeAgo date={updatedAt} />
          </Box>
        )}
        {updatedAt === createdAt && (
          <Box mr={1}>
            <Trans>Created</Trans> <TimeAgo date={createdAt} />
          </Box>
        )}
        <Avatar {...author} />
      </RowBox>
    </RowBox>
  )

  return (
    <Box mb={1}>
      <ActionCard
        variant="navigate"
        title={title}
        detail={
          <>
            {author.firstName} {author.lastName}
          </>
        }
        rightChildren={
          <AuthorTools
            item={knowledge}
            author={author.id}
            onEdit={onEdit}
            onDelete={onDelete}
            onCopy={onCopy}
            onMove={onMove}
            admins={{ edit: "knowledge_update_all", delete: "knowledge_delete_all" }}
          />
        }
        footer={renderFooter()}
        cardProps={{
          component: NavLink,
          to: `/knowledge/article/${id}`
        }}
        elevation={0}
        cy="ListArticle"
      />
    </Box>
  )
})

ListArticle.displayName = "ListArticle"

export { ListArticle }
